module.exports = __webpack_public_path__ + "img/cutMyBillicon.2203c9ae.png";